export const ContentLibraryStoreFeatureKey = `content-library-store`;